import { IProductFilter } from '@/models/products.model';
import { ProductCharacteristicsFormFieldsNames, TProductCharacteristicsFormValues } from './types';

export const getProductFiltersQueryParams = (
  values: TProductCharacteristicsFormValues,
  filters: IProductFilter[],
): Record<string, string> => {
  let filterIndex = 0;
  const allFiltersValues = filters.flatMap((filter) => filter.values.map((value) => value.id));

  return Object.entries(values).reduce((acc: Record<string, string>, [key, value]) => {
    if (key === ProductCharacteristicsFormFieldsNames.CATEGORY) {
      acc.category_id = value as string;
      return acc;
    }

    if (Array.isArray(value)) {
      value.forEach((el) => {
        if (allFiltersValues.includes(el)) {
          acc[`filter_value_ids[${filterIndex}]`] = el;
          filterIndex += 1;
        } else {
          acc[`new_filter_values[${key}][][slug]`] = el;
        }
      });
    } else {
      if (allFiltersValues.includes(value)) {
        acc[`filter_value_ids[${filterIndex}]`] = value;
        filterIndex += 1;
      } else {
        acc[`new_filter_values[${key}][][slug]`] = value;
      }
    }

    return acc;
  }, {});
};
